<template>
  <div class="hfb-page">
    <div class="hfb-card">
      <h1 class="hfb-title">高频轰炸机</h1>

      <div class="hfb-field">
        <label class="hfb-label">手机号码</label>
        <input
          v-model="phone"
          class="hfb-input"
          type="tel"
          inputmode="numeric"
          placeholder="请输入您的手机号码"
        />
      </div>

      <div class="hfb-field">
        <label class="hfb-label">时间选择</label>
        <div class="hfb-select-wrap">
          <select v-model="timeOption" class="hfb-select">
            <option v-for="opt in timeOptions" :key="opt.value" :value="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="hfb-field">
        <label class="hfb-label">模式选择</label>
        <div class="hfb-select-wrap">
          <select v-model="modeOption" class="hfb-select">
            <option v-for="opt in modeOptions" :key="opt.value" :value="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="hfb-field">
        <label class="hfb-label">输入卡密</label>
        <input
          v-model="cardSecret"
          class="hfb-input"
          type="text"
          placeholder="XXXXXXXXXXXXXXXXXXXXXXXXXX"
        />
      </div>

      <div class="hfb-actions">
        <button type="button" class="hfb-btn hfb-btn-start" @click="onStart">启动</button>
        <button type="button" class="hfb-btn hfb-btn-pause" @click="onPause">暂停</button>
        <button type="button" class="hfb-btn hfb-btn-stop" @click="onStop">停止</button>
      </div>

      <button type="button" class="hfb-buy" @click="goBuyCard">购买卡密</button>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { message } from 'ant-design-vue';
import { resolveReferralContext, buildReferralQuery } from '../util/deeplink';

export default {
  name: 'HighFreqBomber',
  setup() {
    const router = useRouter();
    const route = useRoute();
    const phone = ref('');
    const cardSecret = ref('');
    const timeOption = ref('5min');
    const modeOption = ref('sms_low');
    const referral_code = ref('');
    const gameGroupId = ref('');

    const timeOptions = [
      { value: '5min', label: '5分钟试用' },
      { value: '1h', label: '1小时' },
      { value: 'day', label: '天卡' },
      { value: 'week', label: '周卡' },
      { value: 'month', label: '月卡' },
    ];

    const modeOptions = [
      { value: 'sms_low', label: '短信低频轰炸' },
      { value: 'sms_high', label: '短信高频轰炸' },
      { value: 'sms_call', label: '短信 + 电话混合轰炸' },
    ];

    onMounted(() => {
      const ctx = resolveReferralContext(route);
      referral_code.value = ctx.referralCode;
      gameGroupId.value = ctx.gameGroupId;
    });

    const onStart = () => {
      if (!phone.value.trim()) {
        message.warning('请输入手机号码');
        return;
      }
      message.info('已启动');
    };
    const onPause = () => message.info('已暂停');
    const onStop = () => message.info('已停止');

    const goBuyCard = () => {
      router.push({
        name: 'CardSecretBuy',
        query: buildReferralQuery(referral_code.value, gameGroupId.value),
      });
    };

    return {
      phone,
      cardSecret,
      timeOption,
      modeOption,
      timeOptions,
      modeOptions,
      onStart,
      onPause,
      onStop,
      goBuyCard,
    };
  },
};
</script>

<style scoped>
.hfb-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: max(16px, env(safe-area-inset-top)) 16px max(16px, env(safe-area-inset-bottom));
  box-sizing: border-box;
}

.hfb-card {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 28px 24px 32px;
  box-sizing: border-box;
}

.hfb-title {
  margin: 0 0 22px;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  color: #333333;
  letter-spacing: 0.02em;
}

.hfb-field {
  margin-bottom: 16px;
}

.hfb-label {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  color: #666666;
  font-weight: 400;
}

.hfb-input,
.hfb-select {
  width: 100%;
  height: 44px;
  padding: 0 14px;
  font-size: 16px;
  color: #333333;
  background: #ffffff;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  box-sizing: border-box;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
}

.hfb-input::placeholder {
  color: #c0c4cc;
}

.hfb-input:focus,
.hfb-select:focus {
  border-color: #5dade2;
}

.hfb-select-wrap {
  position: relative;
}

.hfb-select-wrap::after {
  content: '';
  position: absolute;
  right: 14px;
  top: 50%;
  width: 0;
  height: 0;
  margin-top: -2px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #909399;
  pointer-events: none;
}

.hfb-select {
  padding-right: 36px;
  cursor: pointer;
}

.hfb-actions {
  display: flex;
  gap: 10px;
  margin-top: 6px;
  margin-bottom: 14px;
}

.hfb-btn {
  flex: 1;
  height: 42px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.hfb-btn:active {
  opacity: 0.88;
}

.hfb-btn-start {
  background: #28a745;
}

.hfb-btn-pause {
  background: #ffc107;
  color: #ffffff;
}

.hfb-btn-stop {
  background: #dc3545;
}

.hfb-buy {
  width: 100%;
  height: 46px;
  border: none;
  border-radius: 6px;
  background: #5dade2;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.hfb-buy:active {
  background: #4a9fd4;
}

@media (max-width: 480px) {
  .hfb-page {
    align-items: flex-start;
    padding-top: 20px;
  }

  .hfb-card {
    max-width: none;
    border-radius: 10px;
    padding: 22px 16px 26px;
    box-shadow: none;
    border: 1px solid #e8e8e8;
  }

  .hfb-actions {
    gap: 8px;
  }

  .hfb-btn {
    font-size: 14px;
    padding: 0 4px;
  }
}
</style>
